import modalBgLg from "../Assets/popup/large.webp";
import modalBgsm from "../Assets/popup/mob.webp";
import { useEffect, useState } from "react";
import { XIcon } from "lucide-react";
import { Link } from "react-router-dom";
const DiscountModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleBookNowClick = () => {
    sessionStorage.setItem("discountCode", "RAMADAN10");
    setIsModalOpen(false);
  };

  // auto open after 20s (once per session)
  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem("autoModalSeen");

    if (!hasSeenModal) {
      const timer = setTimeout(() => {
        setIsModalOpen(true);
        sessionStorage.setItem("autoModalSeen", "true");
      }, 20000);

      return () => clearTimeout(timer);
    }
  }, []);

  // disable scroll when modal open
  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-5">
          <div className="lg:max-w-3xl max-w-[350px] lg:h-[420px] h-4/6 rounded-xl overflow-hidden w-full relative bg-center bg-contain bg-no-repeat">
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-5 right-5 text-black bg-[#9e917d] cursor-pointer"
            >
              <XIcon className="text-white" />
            </button>

            <div className="w-full h-full flex">
              <img
                src={modalBgLg}
                alt=""
                className="w-full h-full object-contain lg:block hidden"
              />
              <img
                src={modalBgsm}
                alt=""
                className="w-full h-full object-cover lg:hidden block"
              />
              <Link to="/properties?discountCode=LOVE20" onClick={handleBookNowClick}>
                <button className="absolute lg:bottom-[60px] bottom-[84px] lg:left-[100px] left-[97px] right-[105px] lg:bg-[#9f9280] bg-[#d9c9ae] lg:text-white text-[#504c47] px-4 text-xl lg:py-[4px] py-[2px] lg:w-32 w-[150px]">
                  Book Now
                </button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DiscountModal;
